import { applyCartFragments } from '../utils/cart-fragments.js'

document.addEventListener('alpine:init', () => {
	window.Alpine.data('directAddToCart', () => ({
		loading: false,

		add(productId) {
			if (this.loading) {
				return
			}

			this.loading = true

			const formData = new FormData()
			formData.append('quantity', 1)
			formData.append('product_id', productId)

			fetch('/?wc-ajax=add_to_cart', {
				method: 'POST',
				body: formData,
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.error) {
						if (data.product_url) {
							window.location = data.product_url
						}

						return
					}

					applyCartFragments(data.fragments)
					this.$nextTick(() => this.$dispatch('cart-updated'))
				})
				.catch(() => null)
				.finally(() => {
					this.loading = false
				})
		},
	}))
})
